/** Which leasing jobs a package is offered to, by the job's leasing company labels. */
export enum PackageLeasingRule {
  ALL = "ALL",
  ONLY_FOR = "ONLY_FOR",
  EXCLUDED_FOR = "EXCLUDED_FOR",
}
